var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBathroomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9241 1.75631C22.5459 1.75631 22.2404 2.06177 22.2404 2.43995V4.47631H20.8441V3.34176C20.8441 1.97449 19.7241 0.854492 18.3568 0.854492H4.5968C6.09498 0.854492 7.30226 2.07631 7.30226 3.55995V17.189H20.8441V5.81449H22.9241C23.3023 5.81449 23.6077 5.50904 23.6077 5.13086V2.4254C23.6077 2.06176 23.3023 1.75631 22.9241 1.75631Z",
    fill: "#C0C8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92753 19.4436H5.9639V5.81445H3.2439V18.7745C3.2439 19.1381 3.54935 19.4436 3.92753 19.4436Z",
    fill: "#C0C8D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59662 2.20715C3.8548 2.20715 3.2439 2.81806 3.2439 3.55988V4.4617H5.94935V3.55988C5.96389 2.80352 5.35299 2.20715 4.59662 2.20715Z",
    fill: "#C0C8D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8475 2.42534C1.8475 2.04715 1.54204 1.7417 1.16386 1.7417C0.785679 1.7417 0.480225 2.04715 0.480225 2.42534V5.14534C0.480225 5.52352 0.785679 5.82898 1.16386 5.82898H3.24386V4.47625H1.8475V2.42534Z",
    fill: "#C0C8D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31659 18.5416H20.8584V20.578H7.31659V18.5416Z",
    fill: "#C0C8D7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroomIcon);
export default __webpack_public_path__ + "static/media/bathroom_icon.3e386cefe16a27e32621ea758951867f.svg";
export { ForwardRef as ReactComponent };